<div class="cards-terms-conditions-wrapper d-flex justify-content-center align-items-center" >
    <div class="spinner-border text-primary" role="status" *ngIf="showLoader">
        <span class="sr-only">Loading...</span>
    </div>
    <div id="cards-terms-conditions" *ngIf="!showLoader" [innerHTML]="termsConditionsHtml"></div>
</div>

